// extracted by mini-css-extract-plugin
export default {"button":"PlugCreateButton_button__apUGE"};